import * as React from "react";
import {Button} from "@mui/material";

interface IAddCustomActionProps {
    onClick(): void;
}

export const AddCustomAction = ({onClick}: IAddCustomActionProps) => (
    <Button
        type="button"
        onClick={onClick}
        variant="contained"
        color="primary"
    >
        Add custom
    </Button>
)
